export const ErrorConstants = {
  NO_ITEMS: "No Items in the cart",
  PAYMENT_MODE: "select Payment Mode",
  ORDER_TYPE: "select order Type",
  PRINT_MODE: "select Print Mode",
  SOMETHING_WRONG: "Something went wrong",
  UNABLE_CHANGE_STATUS: "Unable to change Status, Try Again",
  TERMINAL_NUMBER_IS_REQUIRED: "Terminal number is required",
  PASS_KEY_IS_REQUIRED: "Pass key is required",
  CONTACT_NUMBER_IS_REQUIRED: "Contact number is required",
  PAYMENT_TRANSACTION_IS_FAILED: "Payment transaction is failed",
  PAYMENT_TRANSACTION_IS_TIMEOUT: "Payment transaction is timeout",
  UNABLE_TO_LOGOUT: "Unable to logout",
};
